import { GET_DIAMOND_RAIN_HISTORY, GET_DIAMOND_RAIN_STATS } from "./type";

const initialState = {
    diamondRainHistory: [],
    pagination: null,
    diamondRainStats: {},
};

export const diamondRainHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DIAMOND_RAIN_HISTORY:
            return {
                ...state,
                diamondRainHistory: action.payload.history,
                pagination: action.payload.pagination,
            };

        case GET_DIAMOND_RAIN_STATS:
            return {
                ...state,
                diamondRainStats: action.payload,
            };

        default:
            return state;
    }
};
